const THRESHOLD = 1000;

export const humanReadableNumber = (value) => {
  return value < THRESHOLD ? value : `${(value / THRESHOLD).toFixed(1)}k`;
};

export const getInitials = (firstName, lastName) => {
  try {
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  } catch {
    return "";
  }
};

/**
 * Note: Floats are saved correctly in the database, but during deserialization on the front end,
 * they may lose precision. For example, a value of 1.2 in the database might be deserialized as 1.2000000476837158.
 * @param {Object} data - The data object containing float numbers.
 * @param {number} toFixed - The number of decimal places to format the float numbers to. 2 is the default value.
 * @returns {Object} - The data object with the float numbers formatted to the specified decimal places.
 */
export const normalizeFloatPrecision = (data, toFixed = 2) => {
  Object.keys(data).forEach((key) => {
    if (typeof data[key] === "object" && data[key] !== null) {
      normalizeFloatPrecision(data[key], toFixed);
    } else if (typeof data[key] === "number") {
      data[key] = parseFloat(data[key].toFixed(toFixed));
    }
  });
};
